import SEO from "@/components/SEO";
import Reveal from "@/components/Reveal";
import { FAQ } from "@/data/site";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

export default function Faq() {
  return (
    <div data-testid="page-faq" className="page-enter pt-32">
      <SEO
        title="Questions fréquentes — Psychologue Paris 16e"
        description="Toutes les réponses aux questions fréquentes sur la consultation, la visioconsultation, les tarifs et le cadre."
      />
      <section className="container-fxv py-16 grid lg:grid-cols-12 gap-12">
        <div className="lg:col-span-5">
          <Reveal>
            <p className="overline gold-line">FAQ</p>
          </Reveal>
          <Reveal delay={0.05}>
            <h1 className="font-serif text-5xl md:text-6xl text-[#0C2340] mt-6 leading-[1.05]">
              Vos questions, des réponses claires
            </h1>
          </Reveal>
          <Reveal delay={0.1}>
            <p className="text-[#4A5568] mt-6 text-lg leading-relaxed">
              Voici les questions les plus fréquentes autour de la
              consultation, du déroulement et du cadre déontologique. Une
              question reste sans réponse ? Contactez-moi directement.
            </p>
          </Reveal>
          <Link
            to="/contact"
            className="mt-8 inline-flex items-center gap-2 text-[#0C2340] hover:text-[#C5A059]"
          >
            Poser une question
            <ArrowRight size={16} strokeWidth={1.5} />
          </Link>
        </div>
        <div className="lg:col-span-7">
          <Accordion type="single" collapsible className="w-full">
            {FAQ.map((f, i) => (
              <AccordionItem
                key={f.q}
                value={`item-${i}`}
                className="border-b border-[#E2E8F0]"
              >
                <AccordionTrigger
                  data-testid={`faq-page-trigger-${i}`}
                  className="text-left font-serif text-xl text-[#0C2340] py-6 hover:no-underline"
                >
                  {f.q}
                </AccordionTrigger>
                <AccordionContent className="text-[#4A5568] leading-relaxed pb-6 text-base">
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </section>
    </div>
  );
}
